import defaultColor from "@/components/color";

const dataText = JSON.stringify([
    {
        group:'广州机房',
        data:[
            {name:'Mon',value:120},
            {name:'Tue',value:200},
            {name:'Wed',value:150},
            {name:'Thu',value:80},
            {name:'Fri',value:70},
            {name:'Sat',value:110},
        ]
    },
    {
        group:'深圳机房',
        data:[
            {name:'Mon',value:100},
            {name:'Tue',value:120},
            {name:'Wed',value:70},
            {name:'Thu',value:60},
            {name:'Fri',value:170},
            {name:'Sat',value:90},
        ]
    }
])

export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0,
        // dataText:'{"label":["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],"series":[{"name":"关系1","data": [120,200,150,80,70,110,130]},{"name":"关系2","data": [100,120,70,160,30,110,190]}]}',
        dataText:dataText
    },
    attribute:{
        yAxisRangeRender: false,
        smooth:true,areaShow:false,
        lineColors: defaultColor,
        areaColors: defaultColor,
        xAxis: {
            show: true,
            name: '',
            axisLabel:{
                show: true,
                color: '#6aa9e4'
            },
            axisLine:{
                show: true,
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick:{//x轴刻度线
                show: false 
            },
            splitLine: {//网格线
                show: false
            },
            boundaryGap: true
        },
        yAxis: {
            show: true,
            type: 'value',
            name: '',
            axisLabel:{ 
                show: true,
                color: '#6aa9e4'
            },
            axisLine:{
                show: false,
                lineStyle:{
                    color: '#eee'
                }
            },
            axisTick:{//y轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: true,
                lineStyle:{
                    color: ['#14477e', '#14477e'],
                    type: 'solid' 
                }
            }
        },
        title: {
            text: '',
            //subtext: '纯属虚构',
            left: 'center',
            top: 'top',
            textStyle:{
                fontSize:18,
                color: '#ccc'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        legend: {
            show: true,
            left: 'center',
            top: 'bottom',
            orient: 'horizontal',
            textStyle: {
                color:'#6aa9e4',
                fontSize:14
            }
        },
        grid:{
            x:10,y:30,x2:10,y2:30,
        },
        series:{
            label: {
                show: false, //数值
                position: 'top',
                color: '#ddd',
                fontSize: 13
            }
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        }, 
        lineShow:true,symbolSize:4,
        dataZoom: {show: false,height:15},
        cptTableData: [{ "name": "分组", "value": "", "namekey": "group" },
        { "name": "维度", "value": "", "namekey": "name" },
        { "name": "指标", "value": "", "namekey": "value" }]
    },
}
